import { Grid, Typography, Divider } from "@mui/material";
import React from "react";
import H2 from "ReusableComponents/Text/H2";

const DetailFeatureSection = ({ small, data }) => {
  const columns = small ? 2 : 4; // Dynamically determine the number of columns

  return small ? (
    <Grid
      container
      spacing={2}
      style={{
        width: "100%",
        padding: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <Grid
            item
            xs={12} // Always occupy full width on small screens
            sm={Math.floor(12 / 2)} // Dynamically adjust width based on columns
            md={Math.floor(12 / 2)} // Dynamically adjust width based on columns
            style={{
              textAlign: "center",
              flex: 1,
              minWidth: "40%",
              marginBottom: "20px",
            }} // Ensure even distribution
          >
            <img
              src={item?.attributes?.icon?.data?.attributes?.url}
              alt={item?.attributes?.title}
              style={{
                width: "50px",
                height: "50px",
                marginBottom: "8px",
              }}
            />
            <H2 fontSize={small ? "16px" : "24px"} fontWeight="bold">
              {item?.attributes?.title}
            </H2>
            <p>{item?.attributes?.description}</p>
          </Grid>
          {index % 2 === 0 && index < data.length - 1 && (
            <Divider
              orientation="vertical"
              flexItem
              style={{
                backgroundColor: "grey",
                margin: "0 16px", // Provide some spacing for the divider
                height: "130px", // Set a specific height for the divider
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Grid>
  ) : (
    <Grid
      container
      spacing={2}
      style={{
        width: "100%",
        padding: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {data.map((item, index) => (
        <React.Fragment key={index}>
          <Grid
            item
            xs={12} // Always occupy full width on small screens
            sm={Math.floor(12 / columns)} // Dynamically adjust width based on columns
            md={Math.floor(12 / columns)} // Dynamically adjust width based on columns
            style={{ textAlign: "center", flex: 1 }} // Ensure even distribution
          >
            <img
              src={item?.attributes?.icon?.data?.attributes?.url}
              alt={item?.attributes?.title}
              style={{
                width: "50px",
                height: "50px",
              }}
            />
            <H2>{item?.attributes?.title}</H2>
            <p>{item?.attributes?.description}</p>
          </Grid>
          {index < data.length - 1 && (
            <Divider
              orientation="vertical"
              flexItem
              style={{
                backgroundColor: "grey",
                margin: "0 16px", // Provide some spacing for the divider
                height: "130px", // Set a specific height for the divider
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default DetailFeatureSection;
